// storage key constants for local storage and session storage
export const STORAGE_KEYS = {
    // User stringified storage key
    USER: 'user',
    // App state stringified storage key
    APP_STATE: {
        ACCESS_TOKEN: 'access_token',
        REFRESH_TOKEN: 'refresh_token',
    },
};